import React from 'react'
import "./publicSector.scss"
import CollectionIncrease from './sections/collectionIncrease'
import PublicManagement from './sections/publicManagement'
import WarrantyAndRecoveryList from './sections/warrantyAndRecoveryList'
import Letsgo from "../connectors/letsgo"

function PublicSector() {
  return (
    <div className='container-public-sector'>
      <div className="section-collection-increase">
        <CollectionIncrease />
      </div>
      <div className="section-public-management">
        <PublicManagement />
      </div>
      <div className="section-warranty-and-recovery-list">
        <WarrantyAndRecoveryList />
      </div>
      <div className="section-letsgo">
        <Letsgo />
      </div>
    </div>
  )
}

export default PublicSector